import { render } from "./References.vue?vue&type=template&id=7b0c3696&ts=true"
import script from "./References.vue?vue&type=script&lang=ts"
export * from "./References.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__